/* eslint-disable import/prefer-default-export */
export function toPercentage(value: number, max: number): string {
  const percentage = ((value / max) * 100).toFixed(0);
  return `${percentage}%`;
}
